export const themes = [
    // 'light',
    'aqua',
    'coffee',
    // 'dark',
    'cupcake',
    'bumblebee',
    'emerald',
    // 'corporate',
    'synthwave',
    // 'retro',
    'cyberpunk',
    'valentine',
    'halloween',
    // 'garden',
    'forest',
    'lofi',
    'pastel',
    // 'fantasy',
    // 'wireframe',
    'black',
    // 'luxury',
    'dracula',
    // 'cmyk',
    'autumn',
    'business',
    // 'acid',
    // 'lemonade',
    'night',
    'winter',
    'dim',
    'nord',
    'sunset',
    // 'silk',
    // 'caramellatte',
    // 'abyss',
] as const
